import React from 'react';
import PropTypes from 'prop-types';
const uuid = require('uuid');

const Strings = require('../../../../app/shared/Strings');
const AnalyticsStore = require('../../stores/AnalyticsStore');
const AnalyticsActions = require('../../actions/AnalyticsActions');
import SortableTable2 from '../table/SortableTable2';

const propTypes = {
    channelId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    projectId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
};

const defaultProps = {};

class ProjectActivitiesOverview extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            analyticsStoreState: AnalyticsStore.getState(),
            getPublishedActCountsActionId: null
        };

        this.getProjectPublishedActCounts = this.getProjectPublishedActCounts.bind(this);
        this.unsubscribes = [AnalyticsStore.listen(this.onStoreChange.bind(this, 'analyticsStoreState'))];
    }

    componentDidMount() {
        this.getProjectPublishedActCounts(this.props.projectId);
    }

    componentDidUpdate(prevProps) {
        if (this.props.projectId !== prevProps.projectId) {
            this.getProjectPublishedActCounts(this.props.projectId);
        }
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    getProjectPublishedActCounts(projectId) {
        if (!this.state.analyticsStoreState.projectOverviewAnalytics[projectId]) {
            const getPublishedActCountsActionId = uuid.v4();
            this.setState({ getPublishedActCountsActionId: getPublishedActCountsActionId }, () => {
                AnalyticsActions.getProjectPublishedActCounts(getPublishedActCountsActionId, { id: projectId });
            });
        }
    }

    onStoreChange(storeStateName, state) {
        let additionalState = {};
        if (state.action.id === this.state.getPublishedActCountsActionId) {
            additionalState.getPublishedActCountsActionId = null;
        }

        this.setState({ [storeStateName]: state, ...additionalState });
    }

    render() {
        const self = this;
        const _publishedActCounts = this.state.analyticsStoreState.publishedActProjectCounts[this.props.projectId];
        if (!_publishedActCounts) {
            return null;
        }

        return (
            <div>
                <div className="margin-bottom-lg">
                    <h3 className="md-heading margin-bottom-lg">
                        {Strings['en'].analytics.overview.activity_stats.PUB_SECTION_HEADING}
                    </h3>
                    <div className="sub-heading">
                        {Strings['en'].analytics.overview.activity_stats.PUB_SECTION_DESC}
                    </div>
                        <SortableTable2
                            className="width-100p"
                            classNameTableContainer="tableMaxHeightMdScroll"
                            showTotal={false}
                            hideSearch
                            uniqueRowKey="id"
                            rows={_publishedActCounts}
                            defaultSort={{ key: 'name', type: 'string', asc: true }}
                            columns={[
                                {
                                    displayName: Strings['en'].analytics.overview.activity_stats.TABLE_TEMPLATE_COL,
                                    key: 'name',
                                    size: 2,
                                    type: 'string'
                                },
                                {
                                    displayName: Strings['en'].analytics.overview.activity_stats.TABLE_PUB_ACT_COL,
                                    key: 'count',
                                    size: 2,
                                    type: 'int'
                                },
                            ]}
                        />
                        {(_publishedActCounts.length === 0) &&
                            <div className="font-style-italic text-centered margin-top-md margin-bottom-lg">
                                {Strings['en'].analytics.overview.activity_stats.NO_RECORDS_MSG}
                            </div>
                        }
                </div>
            </div>

        );
    }
}

ProjectActivitiesOverview.propTypes = propTypes;
ProjectActivitiesOverview.defaultProps = defaultProps;

export default ProjectActivitiesOverview;
